import React, { Component } from 'react';
import PropTypes from 'prop-types';


const propTypes = {
  label: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["pending", "published", "synced", "rejected", "unpublished"]),
};

const defaultProps = {
  status: "pending"
}


const StatusLabel = (props) => (
  <div className={`flex justifyBetween statusLabelContainer ${props.status}`}>
    <p className="statusLabel">
      { props.label }
    </p>
  </div>
);


StatusLabel.propTypes = propTypes;
StatusLabel.defaultProps = defaultProps;


export default StatusLabel;
